import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { ContainerScansPluginBackendClient } from './api/ContainerScansPluginBackendClient';
import { containerScansPluginApiRef } from "./api";

import { rootRouteRef } from './routes';

export const containerScansPlugin = createPlugin({
  id: 'container-scans',
  apis: [
    createApiFactory({
      api: containerScansPluginApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new ContainerScansPluginBackendClient({ discoveryApi, identityApi }),
}),
],
  routes: {
    root: rootRouteRef,
  },
});

export const ContainerScansPage = containerScansPlugin.provide(
  createRoutableExtension({
    name: 'ContainerScansPage',
    component: () =>
      import('./components/ContainerScansPage').then(m => m.ContainerScansPage),
    mountPoint: rootRouteRef,
  }),
);
